import bookKobietyPragna from "@/assets/book-kobiety-pragna.jpg.asset.json";
import bookPrzytul from "@/assets/book-przytul.jpg.asset.json";
import bookDziecinstwo from "@/assets/book-dziecinstwo.jpg.asset.json";
import bookKobietyStaraja from "@/assets/book-kobiety-staraja.jpg.asset.json";
import bookOdbuduj from "@/assets/book-odbuduj.jpg.asset.json";
import bookNaucz from "@/assets/book-naucz.jpg.asset.json";
import bookNiekochalni from "@/assets/book-niekochalni.jpg.asset.json";
import logoForbes from "@/assets/media/logo-forbes.png.asset.json";
import logoNewsweek from "@/assets/media/logo-newsweek.png.asset.json";
import logoTvn24 from "@/assets/media/logo-tvn24.png.asset.json";
import logoCharaktery from "@/assets/media/logo-charaktery.png.asset.json";
import logoZwierciadlo from "@/assets/media/logo-zwierciadlo.png.asset.json";
import logoTwojstyl from "@/assets/media/logo-twojstyl.png.asset.json";
import logoPrzygodyPrzedsiebiorcow from "@/assets/media/logo-przygodyprzedsiebiorcow.png.asset.json";
import logoHelloZdrowie from "@/assets/media/logo-hellozdrowie.png.asset.json";
import logoPolki from "@/assets/media/logo-polki.png.asset.json";
import logoWp from "@/assets/media/logo-wp.png.asset.json";
import logoOnet from "@/assets/media/logo-onet.png.asset.json";
import logoRzeczpospolita from "@/assets/media/logo-rzeczpospolita.png.asset.json";
import logoNaTemat from "@/assets/media/logo-natemat.png.asset.json";
import logoDdTvn from "@/assets/media/logo-dziendobrytvn.png.asset.json";
import logoTvp from "@/assets/media/logo-tvp.png.asset.json";
import logoSpotify from "@/assets/media/logo-spotify.png.asset.json";
import logoPolskaTimes from "@/assets/media/logo-polskatimes.png.asset.json";
import logoLongevityWeek from "@/assets/events/longevity-week.png";
import logoAnalizaIt from "@/assets/events/analiza-it.png.asset.json";
import logoTransportCamp from "@/assets/events/transportcamp.png.asset.json";
import logoPolskiKongres from "@/assets/events/polski-kongres.png.asset.json";
import logoDiamenty from "@/assets/events/diamenty-europy.png.asset.json";
import logoMidelCamp from "@/assets/events/midel-camp.png.asset.json";
import logoKozminski from "@/assets/events/kozminski.svg.asset.json";
import logoKbz from "@/assets/events/kbz.jpg.asset.json";
import logoTrojkonferencja from "@/assets/events/trojkonferencja.png";
import logoSwietoKapitalizmu from "@/assets/events/swieto-kapitalizmu.svg";
import logoSlowMedicine from "@/assets/events/slow-medicine.jpg";

export type MediaItem = {
  src?: string;
  icon?: "youtube" | "podcast" | "article";
  name: string;
  /** Link do materiału; jeśli pusty, pozycja wyświetla się jako nazwa bez linku. */
  href?: string;
  /** Tytuł materiału */
  topic: string;
  /** Data publikacji w formacie DD.MM.RRRR */
  date?: string;
  /** Rodzaj materiału: rozmowa audio/wideo albo tekst. */
  kind?: "audio-video" | "article";
};

export type Milestone = {
  year: string;
  label: string;
};

/** Część 1 — rozmowy o biznesie i przywództwie. */
export const mediaLogos: MediaItem[] = [
  {
    src: logoForbes.url,
    name: "Forbes Women",
    href: "https://www.forbes.pl/forbeswomen/od-20-tys-zl-do-20-mln-dlugo-mialam-problem-z-tym-ze-zarabiam-pieniadze/wt7czmz",
    topic: "Od 20 tys. zł do 20 mln. Skalowanie firmy, pieniądze, misja",
  },
  {
    src: logoNewsweek.url,
    name: "Newsweek Polska",
    href: "https://www.newsweek.pl/polska/spoleczenstwo/beata-po-rozstaniu-nie-byla-w-stanie-pracowac-ciagle-plakalam/46yk2kr",
    topic: "Apatia, wypalenie i powrót do sprawczości w pracy",
  },
  {
    src: logoForbes.url,
    name: "Forbes Women 4/2025",
    href: "https://www.forbes.pl/forbeswomen/biznes-i-psychologia-ida-w-parze/wt7czmz",
    topic: "Biznes i psychologia idą w parze",
    kind: "article",
  },
  {
    src: logoPrzygodyPrzedsiebiorcow.url,
    name: "Przygody Przedsiębiorców",
    href: "https://www.youtube.com/watch?v=5tHY6i40iVw",
    topic: "Biznes, stres, depresja. Jak sobie radzić?",
    date: "03.2025",
  },
  {
    src: logoPrzygodyPrzedsiebiorcow.url,
    name: "Przygody Przedsiębiorców",
    href: "https://www.youtube.com/watch?v=CrraySQmChs",
    topic: "Perfekcjonizm, kontrola i wypalenie. Jak psychika niszczy przedsiębiorców",
    date: "2025",
  },
  {
    src: logoTvn24.url,
    name: "TVN24",
    href: "https://tvn24.pl/wideo/z-anteny/sylwia-sitkowska-zalozycielka-przystani-psychologicznej,1802782.html",
    topic: "Sylwia Sitkowska, założycielka Przystani Psychologicznej",
  },
];

/** Część 2 — decyzje, presja i koszty odpowiedzialności. */
export const mediaDecisions: MediaItem[] = [
  {
    src: logoHelloZdrowie.url,
    name: "Hello Zdrowie",
    href: "https://zycie.hellozdrowie.pl/kazdy-czasami-sie-myli-i-jest-to-zupelnie-normalne-jak-decydowac-zeby-potem-nie-zalowac-podpowiada-psycholozka-sylwia-sitkowska/",
    topic: "Jak decydować, żeby potem nie żałować. Model 5 pytań",
  },
  {
    src: logoCharaktery.url,
    name: "Charaktery",
    href: "https://charaktery.eu/artykul/samotnosc-przestrzen-czy-mur",
    topic: "Samotność. Przestrzeń czy mur? (tekst autorski)",
  },
  {
    src: logoCharaktery.url,
    name: "Charaktery",
    href: "https://charaktery.eu/artykul/nawet-jesli-twoje-dziecinstwo-bylo-najgorsze-mozesz-sie-z-niego-wyzwolic-i-zyc-lepiej",
    topic: "Nawet jeśli Twoje dzieciństwo było najgorsze, możesz się z niego wyzwolić i żyć lepiej",
    kind: "article",
  },
  {
    src: logoTwojstyl.url,
    name: "Twój Styl",
    href: "https://twojstyl.pl/artykul/jak-rozmawiac-z-szefem-ktory-ma-duze-ego-i-czego-mozna-sie-od-niego-nauczyc,aid,5457",
    topic: "Jak rozmawiać z szefem, który ma przerośnięte ego?",
    date: "02.2023",
  },
  {
    src: logoTwojstyl.url,
    name: "Twój Styl",
    href: "https://twojstyl.pl/artykul/polka-u-psychologa-te-raport-pokazuje-jak-naprawde-wyglada-sytuacja-pomocy-specjalistycznej-w-naszym-kraju,aid,10706",
    topic: "Polka u psychologa. Raport o rynku pomocy psychologicznej",
    date: "12.2025",
  },
  {
    src: logoTwojstyl.url,
    name: "Twój Styl",
    href: "https://twojstyl.pl/artykul/ai-zamiast-terapeuty-czy-z-chatem-rozmawia-sie-latwiej-niz-z-czlowiekiem,aid,10219",
    topic: "AI zamiast terapeuty. Czy z czatem rozmawia się łatwiej niż z człowiekiem?",
    date: "09.2025",
  },
  {
    src: logoZwierciadlo.url,
    name: "Zwierciadło",
    href: "https://zwierciadlo.pl/psychologia/552730,1,jak-oswoic-zmiany-pytamy-psychoterapeutke-sylwie-sitkowska.read",
    topic: "Jak oswoić zmiany?",
    kind: "article",
  },
  {
    name: "Strona Zdrowia",
    href: "https://stronazdrowia.pl/wypalenie-zawodowe-czy-depresja-ten-sygnal-powinien-zwrocic-twoja-uwage/ar/c14p2-29237297",
    topic: "Wypalenie zawodowe czy depresja? Ten sygnał powinien zwrócić Twoją uwagę",
    date: "2026",
    kind: "article",
  },
  {
    src: logoPolskaTimes.url,
    name: "Polska News",
    href: "https://plus.polskanews.pl/sylwia-sitkowska-bez-kryzysow-nie-ma-rozwoju-w-zwiazkach/ar/c15-16324565",
    topic: "Bez kryzysów nie ma rozwoju w związkach",
    kind: "article",
  },
  {
    src: logoSpotify.url,
    name: "Ukryte piękno, odc. 18",
    href: "https://open.spotify.com/episode/0LpHNVG3lAVdECHbBdhALI",
    topic: "Presja i sukces",
  },
  {
    src: logoZwierciadlo.url,
    name: "Ukryte piękno, odc. 18 (Zwierciadło)",
    href: "https://zwierciadlo.pl/wideo/555438,1,zamartwianie-sie-wchodzi-w-nawyk-i-powoduje-lek-uogolniony-sylwia-sitkowska-o-tym-gdzie-w-ciele-jest-presja.read",
    topic: "Gdzie w ciele jest presja. O zamartwianiu się i lęku uogólnionym",
    date: "01.2026",
    kind: "audio-video",
  },
  {
    icon: "youtube",
    name: "ZNAM TO UCZUCIE",
    href: "https://www.youtube.com/watch?v=lNvB6_X7QUg",
    topic: "Z Wojciechem Eichelbergerem o niezdolności do odpoczywania",
    date: "07.2026",
  },
  {
    icon: "youtube",
    name: "Kafka, odc. 428",
    href: "https://www.youtube.com/watch?v=IKq_6qgZhLM",
    topic: "Kobiety, które pragną zmiany",
  },
  {
    icon: "podcast",
    name: "Podcast Charyzmatyczny",
    href: "https://www.youtube.com/watch?v=UESaDkjCBjM",
    topic: "Jak mieć życie, jakiego chcesz, bez wyrzutów sumienia?",
    date: "09.2025",
  },
  {
    src: logoPolki.url,
    name: "Polki.pl",
    href: "https://stylzycia.polki.pl/zdrowie/po-weekendzie-czujesz-wieksze-zmeczenie-niz-w-piatek-to-znak-ze-jestes-na-kredycie-energetycznym/",
    topic: "Kredyt energetyczny: dlaczego weekend nie regeneruje",
  },
  {
    src: logoWp.url,
    name: "Wirtualna Polska",
    href: "https://kobieta.wp.pl/kobiety-ktore-staraja-sie-za-bardzo-skutki-moga-byc-oplakane-6810484701354592a",
    topic: "Kobiety, które starają się za bardzo: koszty perfekcjonizmu",
  },
  {
    src: logoOnet.url,
    name: "Onet",
    href: "https://www.onet.pl/video/programy/sitkowska-o-ksiazce-kobiety-ktore-staraja-sie-za-bardzo/vp39hy9,6c2ea0e6",
    topic: "Rozmowa wideo o książce „Kobiety, które starają się za bardzo”",
  },
  {
    src: logoRzeczpospolita.url,
    name: "Rzeczpospolita",
    href: "https://kobieta.rp.pl/psychologia/art39138181-toksyczne-dziecinstwo-specjalistka-o-tym-co-moze-zrobic-dla-siebie-dorosly-skrzywdzony-przez-rodzicow",
    topic: "Co dorosły może zrobić dla siebie po trudnym dzieciństwie",
  },
  {
    src: logoNaTemat.url,
    name: "naTemat",
    href: "https://natemat.pl/646525,moje-dzieci-mnie-przerazaja-tak-wymazujemy-rodzicow-ze-swojego-zycia",
    topic: "Zrywanie relacji z rodzicami: perspektywa psychoterapeutki",
  },
  {
    src: logoDdTvn.url,
    name: "Dzień Dobry TVN",
    href: "https://dziendobry.tvn.pl/zdrowie/psychologia/wewnetrzne-dziecko-czym-jest-jak-o-nie-zadbac-st7106442",
    topic: "Wewnętrzne dziecko: czym jest i jak o nie zadbać",
  },
  {
    src: logoDdTvn.url,
    name: "Dzień Dobry TVN",
    href: "https://dziendobry.tvn.pl/zdrowie/psychologia/dziecinstwo-do-poprawki-jak-to-zrobic-co-to-jest-autoterapia-da336045-ls5315301",
    topic: "Dzieciństwo do poprawki. Co to jest autoterapia?",
    kind: "article",
  },
  {
    src: logoTvp.url,
    name: "TVP Pytanie na Śniadanie",
    href: "https://pytanienasniadanie.tvp.pl/45584675/mama-spoliczkowala-dziecko-w-restauracji",
    topic: "Komentarz ekspercki na antenie TVP",
  },
];

/** Część 3 — komentarze eksperckie bez linków. */
export const mediaUnlinkedNames: string[] = [];

/** Materiały prezentowane na stronie (dane strukturalne), bez duplikatów adresu. */
export const mediaAll: MediaItem[] = [];

/** Podcasty i rozmowy wideo, kolejność redakcyjna (pierwsze trzy widoczne bez rozwijania). */
export const mediaPodcasts: MediaItem[] = [
  {
    src: logoPrzygodyPrzedsiebiorcow.url,
    name: "Przygody Przedsiębiorców",
    href: "https://www.youtube.com/watch?v=5tHY6i40iVw",
    topic: "Biznes, stres, depresja. Jak sobie radzić?",
    date: "2025",
    kind: "audio-video",
  },
  {
    icon: "youtube",
    name: "ZNAM TO UCZUCIE",
    href: "https://www.youtube.com/watch?v=lNvB6_X7QUg",
    topic: "Z Wojciechem Eichelbergerem o niezdolności do odpoczywania",
    date: "2026",
    kind: "audio-video",
  },
  {
    icon: "podcast",
    name: "Podcast Charyzmatyczny",
    href: "https://www.youtube.com/watch?v=UESaDkjCBjM",
    topic: "Jak mieć życie, jakiego chcesz, bez wyrzutów sumienia?",
    date: "2025",
    kind: "audio-video",
  },
  {
    icon: "podcast",
    name: "Tygodnik Polityka",
    href: "https://www.youtube.com/watch?v=pH2VY2Ohgak",
    topic: "Zaburzenie afektywne dwubiegunowe: objawy i leczenie ChAD",
    kind: "audio-video",
  },

  {
    src: logoPrzygodyPrzedsiebiorcow.url,
    name: "Przygody Przedsiębiorców",
    href: "https://www.youtube.com/watch?v=CrraySQmChs",
    topic: "Perfekcjonizm, kontrola i wypalenie",
    date: "2025",
    kind: "audio-video",
  },
  {
    src: logoTvn24.url,
    name: "TVN24",
    href: "https://tvn24.pl/wideo/z-anteny/sylwia-sitkowska-zalozycielka-przystani-psychologicznej,1802782.html",
    topic: "Wywiad: założycielka Przystani Psychologicznej",
    kind: "audio-video",
  },
  {
    src: logoDdTvn.url,
    name: "Dzień Dobry TVN",
    href: "https://dziendobry.tvn.pl/zdrowie/psychologia/dziecinstwo-do-poprawki-jak-to-zrobic-co-to-jest-autoterapia-da336045-ls5315301",
    topic: "Dzieciństwo do poprawki. Co to jest autoterapia?",
    kind: "audio-video",
  },
  {
    icon: "youtube",
    name: "Kafka, odc. 428",
    href: "https://www.youtube.com/watch?v=IKq_6qgZhLM",
    topic: "Kobiety, które pragną zmiany",
    kind: "audio-video",
  },
  {
    src: logoZwierciadlo.url,
    name: "Ukryte piękno, odc. 18 (Zwierciadło)",
    href: "https://zwierciadlo.pl/wideo/555438,1,zamartwianie-sie-wchodzi-w-nawyk-i-powoduje-lek-uogolniony-sylwia-sitkowska-o-tym-gdzie-w-ciele-jest-presja.read",
    topic: "O presji i lęku uogólnionym",
    date: "2026",
    kind: "audio-video",
  },

];

/** Artykuły i wywiady prasowe, kolejność redakcyjna. */
export const mediaArticles: MediaItem[] = [
  {
    src: logoForbes.url,
    name: "Forbes Women",
    href: "https://www.forbes.pl/forbeswomen/biznes-i-psychologia-ida-w-parze/wt7czmz",
    topic: "Biznes i psychologia idą w parze",
    date: "2025",
    kind: "article",
  },
  {
    src: logoTwojstyl.url,
    name: "Twój Styl",
    href: "https://twojstyl.pl/artykul/ai-zamiast-terapeuty-czy-z-chatem-rozmawia-sie-latwiej-niz-z-czlowiekiem,aid,10219",
    topic: "AI zamiast terapeuty. Czy z czatem rozmawia się łatwiej niż z człowiekiem?",
    date: "2025",
    kind: "article",
  },
  {
    src: logoTwojstyl.url,
    name: "Twój Styl",
    href: "https://twojstyl.pl/artykul/jak-rozmawiac-z-szefem-ktory-ma-duze-ego-i-czego-mozna-sie-od-niego-nauczyc,aid,5457",
    topic: "Jak rozmawiać z szefem, który ma przerośnięte ego?",
    date: "2023",
    kind: "article",
  },
  {
    src: logoZwierciadlo.url,
    name: "Zwierciadło",
    href: "https://zwierciadlo.pl/psychologia/552730,1,jak-oswoic-zmiany-pytamy-psychoterapeutke-sylwie-sitkowska.read",
    topic: "Jak oswoić zmiany",
    kind: "article",
  },
  {
    src: logoCharaktery.url,
    name: "Charaktery",
    href: "https://charaktery.eu/artykul/nawet-jesli-twoje-dziecinstwo-bylo-najgorsze-mozesz-sie-z-niego-wyzwolic-i-zyc-lepiej",
    topic: "Nawet jeśli Twoje dzieciństwo było najgorsze, możesz się z niego wyzwolić i żyć lepiej",
    kind: "article",
  },
  {
    name: "Strona Zdrowia",
    href: "https://stronazdrowia.pl/wypalenie-zawodowe-czy-depresja-ten-sygnal-powinien-zwrocic-twoja-uwage/ar/c14p2-29237297",
    topic: "Wypalenie zawodowe czy depresja?",
    date: "2026",
    kind: "article",
  },
  {
    src: logoPolskaTimes.url,
    name: "Polska News",
    href: "https://plus.polskanews.pl/sylwia-sitkowska-bez-kryzysow-nie-ma-rozwoju-w-zwiazkach/ar/c15-16324565",
    topic: "Bez kryzysów nie ma rozwoju w związkach",
    kind: "article",
  },
];

const empik = (title: string) =>
  `https://www.empik.com/szukaj/produkt?q=${encodeURIComponent(title)}&qtype=basicForm`;

/** Bezpośrednie karty produktów w Empiku; brak wpisu = wyszukiwarka Empiku. */
export const books = [
  {
    src: bookDziecinstwo.url,
    title: "Dzieciństwo do poprawki",
    tag: "Relacje rodzinne",
    url: "https://www.empik.com/dziecinstwo-do-poprawki-uwolnij-sie-od-cienia-rodzicow-energetycznych-wampirow-sitkowska-sylwia,p1260881545,ksiazka-p",
  },
  {
    src: bookOdbuduj.url,
    title: "Odbuduj bliskość w związku",
    tag: "Bliskość",
    url: "https://www.empik.com/odbuduj-bliskosc-w-zwiazku-ebook-epub-sitkowska-sylwia,p1293957235,ebooki-i-mp3-p",
  },
  {
    src: bookNiekochalni.url,
    title: "Niekochalni. Lęk przed bliskością",
    tag: "Bliskość",
    url: "https://www.empik.com/niekochalni-lek-przed-bliskoscia-gryzewski-andrzej-sitkowska-sylwia,p1240555013,ksiazka-p",
  },
  {
    src: bookKobietyStaraja.url,
    title: "Kobiety, które starają się za bardzo",
    tag: "Perfekcjonizm",
    url: "https://www.empik.com/kobiety-ktore-staraja-sie-za-bardzo-sitkowska-sylwia-katarzyna-troszczynska,p1317299842,ksiazka-p",
  },
  {
    src: bookKobietyPragna.url,
    title: "Kobiety, które pragną zmiany",
    tag: "Zmiana i rozwój",
    url: "https://www.empik.com/kobiety-ktore-pragna-zmiany-sitkowska-sylwia-troszczynska-katarzyna,p1610344445,ksiazka-p",
  },
  {
    src: bookPrzytul.url,
    title: "Przytul swoje wewnętrzne dziecko",
    tag: "Praca z emocjami",
    url: "https://www.empik.com/przytul-swoje-wewnetrzne-dziecko-sitkowska-sylwia,p1367516443,ksiazka-p",
  },
  {
    src: bookNaucz.url,
    title: "Naucz mnie, jak radzić sobie z emocjami",
    tag: "Dla rodziców",
    url: "https://www.empik.com/naucz-mnie-jak-radzic-sobie-z-emocjami-komunikowac-sie-znalezc-przyjaciol-sitkowska-sylwia-kocurowska-maria-berent-damian,p1275949409,ksiazka-p",
  },
].map((book: { src: string; title: string; tag?: string; url?: string }) => ({
  ...book,
  url: book.url ?? empik(book.title),
}));

export const milestones: Milestone[] = [
  {
    year: "2009",
    label:
      "mgr psychologii, Uniwersytet SWPS; założenie Przystani Psychologicznej w Warszawie i start praktyki klinicznej",
  },
  { year: "2014", label: "założenie Szkoły TUS" },
  {
    year: "2016",
    label:
      "ukończenie czteroletniego podyplomowego szkolenia z psychoterapii poznawczo-behawioralnej",
  },
  { year: "2017", label: "początek pracy dydaktycznej na Uniwersytecie SWPS" },
  {
    year: "2020",
    label: 'debiut książkowy: „Niekochalni. Lęk przed bliskością” (z Andrzejem Gryżewskim)',
  },
  {
    year: "2021",
    label:
      '10. placówka sieci; „Dzieciństwo do poprawki”; „Naucz mnie, jak radzić sobie z emocjami, komunikować się, znaleźć przyjaciół”',
  },
  {
    year: "2022",
    label:
      '„Odbuduj bliskość w związku”; „Kobiety, które starają się za bardzo”; „Dzieciństwo do poprawki” wyd. II',
  },
  {
    year: "2023",
    label:
      'Akademia Psychologii Przywództwa (Szkoła Biznesu Politechniki Warszawskiej); „Przytul swoje wewnętrzne dziecko”',
  },
  { year: "2024", label: "20. placówka sieci" },
  { year: "2025", label: 'start doktoratu na Uniwersytecie VIZJA; „Kobiety, które pragną zmiany”' },
  { year: "2026", label: "30 poradni; start mastermindu dla liderów i konsultacji indywidualnych" },
];

export const faqItems: { q: string; a: string[] }[] = [
  {
    q: "Czym różni się Mastermind od konsultacji indywidualnych?",
    a: [
      "Mastermind to kilkumiesięczny proces w stałym, kameralnym gronie: daje wspólnotę i pracę z osobami o podobnej skali odpowiedzialności. Konsultacje indywidualne to elastyczna praca jeden na jeden, bez z góry narzuconego cyklu, formę ustalamy razem na pierwszym spotkaniu. Obie ścieżki są sobie równe, wybór zależy od tego, czego w danym momencie potrzebujesz.",
    ],
  },
  {
    q: "Dla kogo jest Mastermind?",
    a: [
      "Dla właścicieli firm, członków zarządów i liderów, którzy realnie odpowiadają za ludzi i chcą rozwijać się w zaufanym gronie. Do grupy zapraszam po rozmowie kwalifikacyjnej, dbam o to, kto siedzi przy stole.",
    ],
  },
  {
    q: "Czy spotkania są poufne?",
    a: [
      "Tak. Obowiązuje mnie tajemnica zawodowa psychologa i psychoterapeuty. W grupie poufność jest zasadą, którą przyjmujemy wspólnie na starcie i do której wracamy w trakcie procesu, bez niej ta praca nie miałaby sensu. Nic, co powiesz, nie wychodzi poza salę.",
    ],
  },
];

export type EventItem = {
  id: string;
  date: string;
  title: string;
  topic: string;
  place: string;
  href?: string;
  /** Logotyp wydarzenia */
  logo?: string;
  /** Krótki opis wystąpienia — pokazywany w modalu */
  description?: string;
  /** ISO 8601 — do danych strukturalnych Schema.org */
  startDate: string;
  endDate?: string;
  city: string;
  /** Oficjalna strona zapisów/biletów — tylko do danych strukturalnych (offers). */
  ticketsUrl?: string;
  /** Dokładna nazwa obiektu i adres — tylko do danych strukturalnych. */
  venue?: string;
  streetAddress?: string;
};

export const events: EventItem[] = [
  {
    id: "longevity-week-2026",
    date: "19-20 września 2026",
    title: "Longevity Week, ścieżka Mindset",
    topic: "„Długowieczność to nie tylko biologia. Czego o starzeniu uczy nas psychologia?”",
    place: "Gdańsk",
    href: "https://www.gdansk.pl/wydarzenia/Longevity-Week,w,43502",
    logo: logoLongevityWeek,
    startDate: "2026-09-19",
    endDate: "2026-09-20",
    city: "Gdańsk",
  },
  {
    id: "akademia-zwierciadla-2026",
    date: "26 września 2026",
    title: "Wolni od stresu: Akademia Zwierciadła (8. edycja)",
    topic: "Wystąpienie: „Pułapki samooceny: między syndromem oszusta a narcyzmem”",
    place: "Multikino Złote Tarasy, Warszawa oraz online",
    href: "https://zwierciadlo.pl/akademia-zwierciadla/559484,1,wolni-od-stresu-po-raz-osmy-spotkajmy-sie-26-wrzesnia.read",
    logo: logoZwierciadlo.url,
    description:
      "O pułapkach samooceny u osób odpowiedzialnych za innych: jak syndrom oszusta i rysy narcystyczne wpływają na decyzje, relacje i odporność na presję.",
    startDate: "2026-09-26",
    city: "Warszawa",
  },
  {
    id: "global-slow-medicine-2026",
    date: "10 października 2026",
    title: "Global Slow Medicine Conference 2026",
    topic: "Panel dyskusyjny: „Mindset właściciela kliniki”",
    place: "Warszawa",
    href: "https://www.slowmedicine.pl",
    logo: logoSlowMedicine,
    description:
      "Udział w panelu dyskusyjnym dla właścicieli klinik, lekarzy i managerów branży med&beauty o psychologicznych kosztach odpowiedzialności i presji w roli lidera.",
    startDate: "2026-10-10",
    city: "Warszawa",
    ticketsUrl: "https://www.slowmedicine.pl/",
    venue: "Varso Place",
    streetAddress: "ul. Chmielna 73",
  },
  {
    id: "konferencja-trzech-sekcji-2026",
    date: "23-25 października 2026",
    title: "XXI Konferencja Trzech Sekcji Psychoterapeutycznych",
    topic: "Wystąpienie: „AI: zagrożenia i szanse w psychoterapii”",
    place: "Warszawa",
    href: "https://sekcjapsychoterapiiptp.pl/trojkonferencja/",
    logo: logoTrojkonferencja,
    description:
      "Głos w dyskusji o tożsamości zawodowej psychoterapeutów: między regulacją zawodu, praktyką kliniczną a oczekiwaniami rynku.",
    startDate: "2026-10-23",
    endDate: "2026-10-25",
    city: "Warszawa",
    ticketsUrl: "https://sekcjapsychoterapiiptp.pl/trojkonferencja/oplaty-i-zapisy-na-trojkonferencje-2026/",
  },
  {
    id: "swieto-kapitalizmu-2026",
    date: "18-19 listopada 2026",
    title: "Święto Kapitalizmu",
    topic: "Wystąpienie: „Jak nie zwariować, robiąc biznes. Psycha 2.0”",
    place: "Sopot",
    href: "https://swietokapitalizmu.pl/",
    logo: logoSwietoKapitalizmu,
    startDate: "2026-11-18",
    endDate: "2026-11-19",
    city: "Sopot",
    ticketsUrl: "https://swietokapitalizmu.pl/bilety/",
    venue: "Hotel Radisson Blu Sopot",
  },
  {
    id: "wielka-integracja-2027",
    date: "16 stycznia 2027",
    title: "Wielka Integracja Przedsiębiorców 10.0",
    topic: "Wystąpienie (temat zostanie ogłoszony)",
    place: "EXPO Łódź",
    href: "https://www.wielkaintegracja.pl",
    startDate: "2027-01-16",
    city: "Łódź",
    ticketsUrl: "https://www.wielkaintegracja.pl/",
    venue: "EXPO Łódź",
    streetAddress: "al. Politechniki 4",
  },
  {
    id: "longevity-week-2027",
    date: "4-5 czerwca 2027",
    title: "Longevity Week 2027",
    topic: "Wystąpienie (temat zostanie ogłoszony)",
    place: "Gdańsk",
    href: "https://longevityweek.pl/",
    logo: logoLongevityWeek,
    startDate: "2027-06-04",
    endDate: "2027-06-05",
    city: "Gdańsk",
    ticketsUrl: "https://longevityweek.pl/",
    venue: "Doki1",
    streetAddress: "ul. Elektryków 4",
  },
];

/** Wystąpienia, które już się odbyły. */
export const archivedEvents: EventItem[] = [
  {
    id: "diamenty-europy-2026",
    date: "2026",
    title: "Diamenty Europy",
    topic:
      "„Nie da się wspierać biznesu bez wspierania człowieka. O psychice przedsiębiorców i liderów”",
    place: "Kraków",
    href: "https://evenea.pl/wydarzenie/jak-wspierac-w-biznesie-konferencja-diamenty-europy-i0qlv3wj",
    logo: logoDiamenty.url,
    startDate: "2026-06-20",
    city: "Kraków",
  },
  {
    id: "transportcamp-2026",
    date: "2026",
    title: "TransportCamp",
    topic: "„Zmęczony lider to zmęczony biznes. Jak temu zapobiec?”",
    place: "Wrocław",
    href: "https://transportcamp.pl",
    logo: logoTransportCamp.url,
    startDate: "2026-01-14",
    city: "Wrocław",
  },
  {
    id: "analiza-it-2026",
    date: "21 marca 2026",
    title: "Konferencja Analiza IT",
    topic: "„Dlaczego najlepsi wypalają się pierwsi”",
    place: "Multikino Złote Tarasy, Warszawa",
    href: "https://www.analizait.pl/konferencja-analiza-it/",
    logo: logoAnalizaIt.url,
    startDate: "2026-03-21",
    city: "Warszawa",
  },
  {
    id: "going-global-2026",
    date: "17 marca 2026",
    title: "Akademia Leona Koźmińskiego, konferencja Going Global",
    topic: "„Psychologia w biznesie: jak z jednej poradni powstało trzydzieści”",
    place: "Warszawa",
    href: "https://www.linkedin.com/company/international-business-student-summit-going-global",
    logo: logoKozminski.url,
    startDate: "2026-03-17",
    city: "Warszawa",
  },
  {
    id: "kongres-przedsiebiorczosci-2025",
    date: "20-21 października 2025",
    title: "XII Polski Kongres Przedsiębiorczości",
    topic: "Udział w panelu „Kobieta i biznes” oraz nagroda „Sukces w Szpilkach”",
    place: "Hala Stulecia, Wrocław",
    href: "https://polskikongres.pl/",
    logo: logoPolskiKongres.url,
    startDate: "2025-10-20",
    endDate: "2025-10-21",
    city: "Wrocław",
  },
  {
    id: "midel-camp-2025",
    date: "wrzesień 2025",
    title: "Midel Camp, scena główna",
    topic:
      "„Samotność lidera. O blaskach i cieniach sukcesu, który widzą wszyscy, i ciężarze, który znasz tylko Ty”",
    place: "Sopot",
    href: "https://www.midelcamp.pl/",
    logo: logoMidelCamp.url,
    startDate: "2025-09-01",
    city: "Sopot",
  },
  {
    id: "sniadanie-biznesowe-2025",
    date: "2025",
    title: "Śniadanie biznesowe dla przedsiębiorców",
    topic: "„Jak zadbać o siebie, zanim zadbamy o innych”",
    place: "Kalisz",
    startDate: "2025-01-01",
    city: "Kalisz",
  },
  {
    id: "kongres-bezpieczenstwa-zywnosci-2024",
    date: "2 października 2024",
    title: "XI Kongres Bezpieczeństwa Żywności",
    topic: "Panel „Dobrostan pracowników i jego długoterminowy wpływ na organizację”",
    place: "Warszawa",
    href: "https://foodcongress.org/",
    logo: logoKbz.url,
    startDate: "2024-10-02",
    city: "Warszawa",
  },
];

function normalizedStartDate(event: EventItem): string {
  return /^\d{4}$/.test(event.startDate) ? `${event.startDate}-01-01` : event.startDate;
}

function normalizedEndDate(event: EventItem): string {
  const raw = event.endDate ?? event.startDate;
  return /^\d{4}$/.test(raw) ? `${raw}-12-31` : raw;
}

function warsawDate(date: Date): string {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Europe/Warsaw",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);
  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${values["year"]}-${values["month"]}-${values["day"]}`;
}

/**
 * Automatycznie dzieli wszystkie wydarzenia według ich ostatniego dnia.
 * Wydarzenie pozostaje w „Najbliższych” przez cały dzień zakończenia.
 * Data zawierająca tylko rok jest ostrożnie traktowana jako 31 grudnia.
 */
export function splitEvents(referenceDate = new Date()) {
  const today = warsawDate(referenceDate);
  const completedUpcoming = events
    .filter((event) => normalizedEndDate(event) < today)
    .sort((a, b) => normalizedEndDate(b).localeCompare(normalizedEndDate(a)));

  return {
    upcoming: events
      .filter((event) => normalizedEndDate(event) >= today)
      .sort((a, b) => normalizedStartDate(a).localeCompare(normalizedStartDate(b))),
    past: [...completedUpcoming, ...archivedEvents],
  };
}

mediaAll.push(
  ...[...mediaPodcasts, ...mediaArticles].filter(
    (item, i, arr) => arr.findIndex((x) => x.href === item.href) === i,
  ),
);
